import type {BaseCar, CarAuction, CarItem} from "@/types";

export function calculateScore(car: CarItem | CarAuction) {
    let score = 0;

    const imageScore = Math.min((car.images?.length ?? 0) / 10, 1) * 20;
    const videoScore = car.video?.length ? 5 : 0;
    score += imageScore + videoScore;

    let core = 0;
    if (car.name) core += 4;
    if (car.brand) core += 4;
    if (car.model) core += 4;
    if (car.year) core += 4;
    if (car.type === "listing" && car.price) core += 4;
    if (car.type === "auction" && car.startingBid) core += 4;
    score += core;

    let specs = 0;
    if (car.mileage !== undefined) specs += 3;
    if (car.transmission) specs += 3;
    if (car.fuelType) specs += 3;
    if (car.engine) specs += 2;
    if (car.capacity) specs += 2;
    if (car.drivetrain) specs += 2;
    score += specs;

    let details = 0;
    if (car.condition) details += 2;
    if (car.body) details += 2;
    if (car.color) details += 2;
    if (car.interior) details += 1;
    if (car.seats !== undefined) details += 1;
    if (car.doors !== undefined) details += 1;
    if (car.owners !== undefined) details += 1;
    score += details;

    let desc = 0;
    const description = car.description;
    if (description?.general) {
        desc += Math.min(description.general.length / 300, 1) * 8;
    }
    if (description?.highlights) desc += 2;
    if (description?.equipment) desc += 2;
    if (description?.serviceHistory) desc += 2;
    if (description?.knownFlaws) desc += 1;
    score += desc;

    let docs = 0;
    if (car.vin) docs += 4;
    if (car.titleStatus) docs += 3;
    if (description?.serviceHistory) docs += 3;
    score += docs;

    let trust = 0;
    if (car.verified) trust += 2;
    if (car.warranty) trust += 1;
    if (car.isDealer) trust += 1;
    if (car.seller) trust += 1;
    score += trust;

    return Math.round(score);
}

export function getMissing(car: BaseCar | CarItem | CarAuction) {
    const missing: string[] = [];

    if (!car.images?.length) missing.push("Add images");
    if (!car.description?.general) missing.push("Add description");
    if (car.type === "listing" && !("price" in car && car.price)) missing.push("Set price");
    if (car.type === "auction" && !("startingBid" in car && car.startingBid)) missing.push("Set starting bid");
    if (car.mileage === undefined) missing.push("Add mileage");
    if (!car.vin) missing.push("Add VIN");
    if (!car.engine) missing.push("Add engine details");
    if (!car.video?.length) missing.push("Add video");

    return missing;
}

export function getLevel(score: number) {
    if (score < 40) return "Poor";
    if (score < 70) return "Average";
    if (score < 90) return "Good";
    return "Excellent";
}
